"use client";

import { useState } from "react";
import Image from "next/image";

import { cn } from "@/lib/utils";

import { AspectRatio } from "@/components/ui/aspect-ratio";

interface ImageGalleryProps {
  images: string[];
  alt?: string;
}

export function ImageGallery({ images, alt = "" }: ImageGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (images.length === 0) {
    return (
      <div className="w-full">
        <AspectRatio ratio={1}>
          <div className="w-full h-full bg-muted flex items-center justify-center rounded-none">
            <span className="text-muted-foreground text-sm">이미지 없음</span>
          </div>
        </AspectRatio>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-3">
      <AspectRatio ratio={1}>
        <Image
          src={images[activeIndex]}
          alt={`${alt} ${activeIndex + 1}`}
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
          priority
          className="object-cover rounded-none"
        />
      </AspectRatio>

      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {images.map((src, index) => (
            <button
              key={index}
              type="button"
              onClick={() => setActiveIndex(index)}
              className={cn(
                "shrink-0 w-16 h-16 rounded-none overflow-hidden border-2 transition-colors relative",
                activeIndex === index
                  ? "border-primary ring-2 ring-primary ring-offset-1"
                  : "border-transparent hover:border-border",
              )}
              aria-label={`이미지 ${index + 1} 보기`}
            >
              <Image
                src={src}
                alt={`${alt} 썸네일 ${index + 1}`}
                fill
                sizes="64px"
                className="object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
